import PropTypes from 'prop-types';
import { createContext, FC, ReactNode, useEffect, useMemo, useState } from 'react';
import MESSAGES from '../common/data/constants/messages';
import { IUserProps } from '../common/data/userDummyData';
import { showWarning } from '../components/extras/Notifications';
import { getFirstName, getLastName } from '../helpers/helpers';
import LoadingPage from '../pages/presentation/loading/LoadingPage';
import employeeService from '../services/employee-service';

export interface IAuthContextProps {
	user: string;
	setUser?(...args: unknown[]): unknown;
	userData: Partial<IUserProps>;
}
const AuthContext = createContext<IAuthContextProps>({} as IAuthContextProps);

interface IAuthContextProviderProps {
	children: ReactNode;
}
export const AuthContextProvider: FC<IAuthContextProviderProps> = ({ children }) => {
	const [user, setUser] = useState<string>(localStorage.getItem('safeGear_authUsername') || '');
	const [userData, setUserData] = useState<Partial<IUserProps>>({});

	const [isLoading, setIsLoading] = useState<boolean>(false);

	useEffect(() => {
		localStorage.setItem('safeGear_authUsername', user);
	}, [user]);

	useEffect(() => {

		const fetchUserData = async () => {

			try {
				if (user === '') {
					setUserData({});
				} else {

					const response = await employeeService.getByEmail(user);

					if (response.success && response.employee) {
						const userProps: IUserProps = {
							id: '',
							email: user,
							fullName: response.employee.name,
							name: getFirstName(response.employee?.name ?? ''),
							surname: getLastName(response.employee?.name ?? ''),
							username: user,
							firstAccess: false,
							taxId: response.employee.taxId,
							corporateName: response.employee.corporateName,
							jobTitle: response.employee.jobTitle,
							costCenter: response.employee.costCenter,
							menus: response.employee.menus ?? []
						};

						setUserData(userProps);
					} else {
						setUserData({});
					}
				}
			} catch {
				showWarning(MESSAGES.LOGIN.GET_BY_EMAIL_ERROR);
				setUserData({});
				setIsLoading(false);
			}
		};

		fetchUserData();


	}, [user]);

	const value = useMemo(
		() => ({
			user,
			setUser,
			userData,
		}),
		[user, userData],
	);

	if (isLoading) {
		return <LoadingPage />;
	}

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
AuthContextProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AuthContext;
